import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

function getDefaultState() {
  return {
    user: null,
    signupEmail: null,
    isOptInEmail: null,
    p: null,
    k: null,
    loginTransitionPagePath: null,
    forgotPasswordEmail: null,
    referrer: null,
    fromVerifySignup: false,
    fromSignup: false,
    fromVerifyForgotPassword: false,
    fromVerifyChangePassword: false,
    fromVerifyChangeEmail: false,
  }
}

const persistedState = createPersistedState({
  key: 'ALC-EOWP-RegCenter',
  paths: [
    'user.id', 
    'signupEmail', 
    'isOptInEmail', 
    'loginTransitionPagePath', 
    'forgotPasswordEmail', 
    'p', 
    'referrer', 
    'k', 
    'fromVerifySignup', 
    'fromSignup', 
    'fromVerifyForgotPassword', 
    'fromVerifyChangePassword', 
    'fromVerifyChangeEmail'
  ],
});

export default new Vuex.Store({
  plugins: [persistedState],
  state: getDefaultState(),
  mutations: {
    clearAuthData(state) {
      Object.assign(state, getDefaultState())
    },
    setUser(state, user) {
      state.user = user
    },
    setLoginTransitionPagePath(state, loginTransitionPagePath) {
      state.loginTransitionPagePath = loginTransitionPagePath
    },
    setForgotPasswordEmail(state, forgotPasswordEmail) {
      state.forgotPasswordEmail = forgotPasswordEmail
    },
    setSignupEmail(state, signupEmail) {
      state.signupEmail = signupEmail
    },
    setP(state, p) {
      state.p = p
    },
    setK(state, k) {
      state.k = k
    },
    setIsOptInEmail(state, isOptInEmail) {
      state.isOptInEmail = isOptInEmail
    },
    setReferrer(state, referrer) {
      state.referrer = referrer
    },
    setFromVerifySignup(state, fromVerifySignup) {
      state.fromVerifySignup = fromVerifySignup
    },
    setFromSignup(state, fromSignup) {
      state.fromSignup = fromSignup
    },
    setFromVerifyForgotPassword(state, fromVerifyForgotPassword) {
      state.fromVerifyForgotPassword = fromVerifyForgotPassword
    },
    setFromVerifyChangePassword(state, fromVerifyChangePassword) {
      state.fromVerifyChangePassword = fromVerifyChangePassword
    },
    setFromVerifyChangeEmail(state, fromVerifyChangeEmail) {
      state.fromVerifyChangeEmail = fromVerifyChangeEmail
    },
  },
  actions: {},
  modules: {},
})
